(() => {
  const WRAPPER_SEL = '#load-more-wrapper';
  const LIST_INNER_SEL = 'product-list .product-list__inner';

  async function fetchAndAppend(nextUrl) {
    const res = await fetch(nextUrl, { credentials: 'same-origin' });
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const currentInner = document.querySelector(LIST_INNER_SEL);
    const nextInner = doc.querySelector(LIST_INNER_SEL);

    const newNodes = Array.from(nextInner.children);
    newNodes.forEach((node) => currentInner.appendChild(node));
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest(`${WRAPPER_SEL} a[rel="next"]`);
    if (!btn) return;

    e.preventDefault();

    try {
      await fetchAndAppend(btn.href);
      const wrapper = document.querySelector(WRAPPER_SEL);

      const res = await fetch(btn.href);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextWrapper = doc.querySelector(WRAPPER_SEL);

      if (nextWrapper) {
        wrapper.innerHTML = nextWrapper.innerHTML;
      } else {
        wrapper.remove();
      }

    } catch (err) {
      window.location.href = btn.href;
    }
  });
})();
